import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavBar from '../../shared/NavBar';
import PageMetadata from '../../shared/PageMetadata';
import { PAGE_METADATA } from '../../pageMetadata';
import { getAppLoginUrl } from '../../shared/appUrl';
import laptopMockup from '../../assets/laptop-mockup.png';
import { testClubPath, testClubTitle, testClubLead, testClubSteps, testClubExpiry, testClubFree, testClubPlatform, testClubLinks } from './testClubContent';
import './TestClubPage.css';

export default function TestClubPage() {
  useEffect(() => {
    const canonical = document.createElement('link');
    canonical.rel = 'canonical';
    canonical.href = `https://www.shuttleops.com${testClubPath}`;
    document.head.appendChild(canonical);
    return () => canonical.remove();
  }, []);
  return <>
    <PageMetadata metadata={PAGE_METADATA[testClubPath]} />
    <header className="test-club-hero">
      <NavBar />
      <div className="test-club-hero__layout">
        <div><h1>{testClubTitle}</h1><p>{testClubLead}</p>
          <a className="test-club-start" data-test-club-cta="landing-hero" href={getAppLoginUrl()}>Open ShuttleOps to try a test club <span aria-hidden="true">↗</span></a>
          <small>Create an account. No card or setup call. On Clubs, open the three-line menu beside its heading.</small>
        </div>
        <figure><img src={laptopMockup} alt="ShuttleOps club session view on a laptop" /><figcaption>Your own practice space. Your real players can wait.</figcaption></figure>
      </div>
    </header>
    <main className="test-club-main">
      <section className="test-club-steps" aria-labelledby="test-club-steps-title">
        <h2 id="test-club-steps-title">Four steps to your first practice session</h2>
        <ol>{testClubSteps.map((step, i) => <li key={step.title}><span aria-hidden="true">0{i + 1}</span><div><h3>{step.title}</h3><p>{step.text}</p></div></li>)}</ol>
      </section>
      <section className="test-club-after" aria-labelledby="test-club-after-title">
        <div><h2 id="test-club-after-title">What happens after seven days?</h2><p>{testClubExpiry}</p></div>
        <div><h3>A test club is separate from the ongoing Free plan</h3><p>{testClubFree}</p></div>
      </section>
      <section className="test-club-platform"><h2>Built for the whole club night</h2><p>{testClubPlatform}</p></section>
      <nav className="test-club-related" aria-label="Related ShuttleOps pages">{testClubLinks.map(([href, label]) => <Link key={href} to={href}>{label} <span aria-hidden="true">→</span></Link>)}</nav>
    </main>
  </>;
}
